/**
 * Here separately so we can automate the generation of this file using the
 * Lokalize API at some future point. JS and not JSON so I can write this
 * freaking message.
 *
 * Separated out by type of message in case (e.g. `maintenance`) in case we
 * have more types of messages to display at the container level (we should try
 * our best to avoid this...)
 */

export default {
  maintenance: {
    "en-CA": {
      title: "Granular is currently down for maintenance",
      message:
        "We are upgrading our systems to deliver you the best product possible and will be back soon.",
    },
    "en-US": {
      title: "Granular is currently down for maintenance",
      message:
        "We are upgrading our systems to deliver you the best product possible and will be back soon.",
    },
    "fr-CA": {
      title:
        "Granular est actuellement indisponible en raison d'une maintenance visant à mettre à jour l'ensemble du système.",
      message:
        "Nous sommes en train de faire des mises à jour de nos systèmes pour vous fournir le meilleur produit possible et nous reviendrons bientôt.",
    },
    "pt-BR": {
      title:
        "Granular está atualmente indisponível em razão de uma manutenção do sistema.",
      message:
        "Estamos atualizando nossos sistemas para lhe entregar o melhor produto possível e em breve o sistema estará disponível.",
    },
  },
};
